import React from 'react';
import {Select} from "antd";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

const ComparisonRecord = () => {
    return (
        <div className="main-padding  ">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>Comparison Record</span>
            </div>

            <div className="camera-config-content">

                <div className="control-header-cmcf my-avform">
                    <div className="d-flex align-items-center">
                        <Select

                            placeholder="Поиск, чтобы выбрать"
                            optionFilterProp="children"

                        >
                            <option value="1">All</option>
                            <option value="3">White List</option>
                            <option value="3">Black List</option>
                            <option value="2">VIP</option>
                        </Select>
                        <input type="datetime-local" className="p-2 ml-8"/>
                        <span className="text-white ml-8 mr-8">to</span>
                        <input type="datetime-local"  className="p-2   mr-16"/>
                        <div className="input-group  " style={{width: "220px", height: "42px"}}>
                            <input type="text" className="form-control h-100" placeholder="Enter username" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                            <div className="input-group-append h-100">
                                <button className="btn btn-primary h-100   " style={{borderRadius: "0 6px 6px 0"}} type="button">
                                    <img src="/icon/loupe.png" className="w-75" style={{marginTop: "-5px"}} alt="..."/>
                                </button>
                            </div>
                        </div>
                        <div className="input-group ml-24" style={{width: "220px", height: "42px"}}>
                            <input type="text" className="form-control h-100" placeholder="ID" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                            <div className="input-group-append h-100">
                                <button className="btn btn-primary h-100   " style={{borderRadius: "0 6px 6px 0"}} type="button">
                                    <img src="/icon/loupe.png" className="w-75" style={{marginTop: "-5px"}} alt="..."/>
                                </button>
                            </div>
                        </div>
                        <button className="btn btn-success ml-24"  >Export</button>
                        <button className="btn btn-success ml-8" >Export All</button>
                    </div>
                </div>

                <div className="emp-table mt-4">
                    <TableContainer component={Paper}>
                        <Table sx={{minWidth: 650}} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className="pl20 table-head" align="left">ID</TableCell>
                                    <TableCell className="table-head" align="left">name</TableCell>
                                    <TableCell className="table-head" align="left">device_mac</TableCell>
                                    <TableCell className="table-head" align="left">lib_platform_version</TableCell>
                                    {/*<TableCell className="table-head" align="left">software_version</TableCell>*/}
                                    <TableCell className="table-head" align="left">lib_ai_version</TableCell>
                                    <TableCell className="table-head" align="left">device_ip</TableCell>
                                    <TableCell className="table-head" align="left">building_id</TableCell>
                                    <TableCell className="table-head" align="left">room_id</TableCell>
                                    <TableCell className="table-head" align="left">camera_type</TableCell>
                                    <TableCell className="table-head" align="left">device_name</TableCell>
                                    <TableCell className="pr20 table-head" align="right">
                                        Действие
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell className="pl20 text-white" component="th" scope="row">
                                        1
                                    </TableCell>
                                    <TableCell className="text-white" align="left">name</TableCell>
                                    <TableCell className="text-white" align="left">device_mac</TableCell>
                                    <TableCell className="text-white" align="left">lib_platform_version</TableCell>
                                    <TableCell className="text-white" align="left">lib_ai_version</TableCell>
                                    <TableCell className="text-white" align="left">device_ip</TableCell>
                                    <TableCell className="text-white" align="left">building</TableCell>
                                    <TableCell className="text-white" align="left">room?.name</TableCell>
                                    {/*<TableCell align="left">{row.lib_ai_version}</TableCell>*/}
                                    <TableCell className="text-white" align="left">camera_type</TableCell>
                                    <TableCell className="text-white" align="left">camera_type</TableCell>
                                    <TableCell className="text-white" align="right">device_name</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </div>
    );
};

export default ComparisonRecord;